import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OfflineFeatureName, OfflineState } from '.';

export const getOfflineState =
  createFeatureSelector<OfflineState>(OfflineFeatureName);

const getDprDetailsList = createSelector(
  getOfflineState,
  (state) => state.dprDetailsList
);

const getDprDetails = createSelector(
  getOfflineState,
  (state) => state.dprDetails
);

const getBackupUserDetails = createSelector(
  getOfflineState,
  (state) => state.backupUserDetails
);

const getBackupLastDprs = createSelector(
  getOfflineState,
  (state) => state.backupLastDprs
);

const getBackupAuthenticationResult = createSelector(
  getOfflineState,
  (state) => state.backupAuthenticationResult
);

const getDprDetailsOfflineChanges = createSelector(
  getOfflineState,
  (state) => state.dprDetailsOfflineChanges
);

const getSyncOfflineGuid = createSelector(
  getOfflineState,
  (state) => state.syncOfflineGuid
);

const getCombinedDprDetailsList = createSelector(
  getDprDetailsList,
  getDprDetails,
  (dprDetailsList, dprDetails) =>
    !!dprDetails && !(dprDetailsList ?? []).some((x) => x.id === dprDetails.id)
      ? [...(dprDetailsList ?? []), dprDetails]
      : dprDetailsList
);

const getMostRecentDprDetails = createSelector(
  getDprDetailsList,
  (dprDetailsList) => (dprDetailsList ? dprDetailsList[0] : null)
);

export const offlineQuery = {
  getDprDetailsList,
  getDprDetails,
  getBackupUserDetails,
  getBackupLastDprs,
  getBackupAuthenticationResult,
  getDprDetailsOfflineChanges,
  getSyncOfflineGuid,
  getCombinedDprDetailsList,
  getMostRecentDprDetails,
};
